import { useEffect, useState } from 'react';

const MOBILE_QUERY = '(max-width: 767.98px)';

const matches = (): boolean => typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches;

/**
 * Tracks the phone breakpoint for the cases CSS cannot cover — component props
 * such as antd sizing tokens or layout modes that have to change, not just look different.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    const onChange = (event: MediaQueryListEvent): void => setIsMobile(event.matches);

    mediaQuery.addEventListener('change', onChange);

    return () => mediaQuery.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
